import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div ``;
export const IconChecklist = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            const firstRow = wrapper?.querySelector('g g:nth-child(1)');
            const firstRowPaths = firstRow?.querySelectorAll('path');
            const secondRow = wrapper?.querySelector('g g:nth-child(2)');
            const thirdRow = wrapper?.querySelector('g g:nth-child(3)');
            if (!firstRow || !firstRowPaths || !secondRow || !thirdRow) {
                return;
            }
            gsap.to([secondRow, thirdRow], {
                y: 4.17,
                duration: 0.25,
                onComplete: () => {
                    gsap.to(firstRowPaths, {
                        opacity: 1,
                        stagger: -0.15,
                        duration: 0.2,
                        ease: 'linear',
                        onComplete: () => {
                            triggerDone();
                            gsap.to([firstRow, secondRow, thirdRow, firstRowPaths], {
                                clearProps: true,
                                duration: 0,
                            });
                        },
                    });
                },
            });
            gsap.to(thirdRow, {
                opacity: 0,
                duration: 0.15,
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Checklist, null)));
};
//# sourceMappingURL=Checklist.js.map